import React from 'react';
import Slider from 'react-slick';
import Test_1 from '../../../assets/images/testimonials/01.png'
import Test_2 from '../../../assets/images/testimonials/02.png'
import Test_3 from '../../../assets/images/testimonials/03.png'
import Test_4 from '../../../assets/images/testimonials/04.png'
import Test_5 from '../../../assets/images/testimonials/05.png'
import Test_6 from '../../../assets/images/testimonials/06.png'

const Testmonial = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    return (
        <section id="testimonials" className="testimonials-main-block">
            <div className="container">
                <div className="testimonial-slider">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="testimonial-img-slider">
                                <Slider {...settings}>
                                    <div className="testimonials-img">
                                        <img
                                            src={Test_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                    <div className="testimonials-img">
                                        <img
                                            src={Test_2}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                    <div className="testimonials-img">
                                        <img
                                            src={Test_3}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                </Slider>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <Slider {...settings}>
                                <div className="testimonials-block">
                                    <div className="testimonial-img-dtl-block">
                                        <div className="testimonial-img">
                                            <img
                                                src={Test_4}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                        <div className="testimonial-dtl">
                                            <h4 className="heading">Zaniyah Henderson</h4>
                                            <p className="about">CTO&amp;MD, Accent Co.</p>
                                        </div>
                                    </div>
                                    <p>
                                        Nor again is there anyone who loves or pursues or desires to
                                        obtain pain of itself,because it is pain, but because
                                        occasionally circumstances occur in which toil and pain can
                                        procure him some great pleasure.
                                    </p>
                                    <ul className="star-icon">
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="testimonials-block">
                                    <div className="testimonial-img-dtl-block">
                                        <div className="testimonial-img">
                                            <img
                                                src={Test_5}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                        <div className="testimonial-dtl">
                                            <h4 className="heading">Zaniyah Henderson</h4>
                                            <p className="about">CTO&amp;MD, Accent Co.</p>
                                        </div>
                                    </div>
                                    <p>
                                        Nor again is there anyone who loves or pursues or desires to
                                        obtain pain of itself,because it is pain, but because
                                        occasionally circumstances occur in which toil and pain can
                                        procure him some great pleasure.
                                    </p>
                                    <ul className="star-icon">
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="testimonials-block">
                                    <div className="testimonial-img-dtl-block">
                                        <div className="testimonial-img">
                                            <img
                                                src={Test_6}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                        <div className="testimonial-dtl">
                                            <h4 className="heading">Zaniyah Henderson</h4>
                                            <p className="about">CTO&amp;MD, Accent Co.</p>
                                        </div>
                                    </div>
                                    <p>
                                        Nor again is there anyone who loves or pursues or desires to
                                        obtain pain of itself,because it is pain, but because
                                        occasionally circumstances occur in which toil and pain can
                                        procure him some great pleasure.
                                    </p>
                                    <ul className="star-icon">
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                        <li>
                                            <i className="flaticon-star" />
                                        </li>
                                    </ul>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testmonial;
